<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("clients") }}</div>
        <div class="section-subTitle my-2">Manage All your Clients Here.</div>
      </div>
      <div>
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <!-- v-if="cinema_manager_add_edit_disabled != 3" -->
        <b-button
          variant="default"
          :to="{ path: 'add-client' }"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container">
      <div class="desg-list-header">
        <div>Client Name</div>

        <div class="pr-3">{{ $tc("status", 2) }}</div>
      </div>
      <ul class="desg-list" v-if="clientList.length>0">
        <li v-for="(client, clientKey) in clientList" :key="clientKey">
          <div>{{ client.client_name }}</div>

          <div class="d-flex align-items-center">
            <!-- <label class="ios-switch">
              <input
                value="Y"
                v-model="client.client_is_active"
                disabled
                type="checkbox"
                class="ios-checkbox"
              />
              <span class="switch-slider"></span>
            </label> -->
            <StatusDot
              :status="client.client_is_active ? 'active' : 'inactive'"
            />
            <b-dropdown right variant="edit" class="ml-4">
              <b-dropdown-item
                :to="{
                  path: 'edit-client',
                  query: { client_id: client.client_id }
                }"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t("edit") }}
              </b-dropdown-item>
              <b-dropdown-item
                :to="{
                  path: 'view-client',
                  query: { client_id: client.client_id }
                }"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t("view") }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </li>
      </ul>
      <div class="pb-3" v-else>
        <NoRecords classes="mb-0"/>
      </div>
    </div>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import ClientService from "@/services/ClientService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      clientList: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: null
    };
  },
  mounted() {
    this.getClientList();
  },
  methods: {
    getClientList() {
      ClientService.GetAllClients({
        limit: this.perPage,
        currentPage: this.currentPage
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.clientList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getChecklists();
      } else {
        this.currentPage = event;
        this.getChecklists();
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 4 },
        { name: "40", id: 5 },
        { name: "50", id: 6 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ClientComponent/clients.vue